<div class="main-container" #labelledContainer [class.full-width]="isFullWidth">
  <div class="label-container" [class.full-width]="isFullWidth">
    <nts-label-box (click)="isLabelZoomEnabled ? openZoom() : null" [class.zoom-label]="isLabelZoomEnabled"
      [title]="description" [label]="displayName"></nts-label-box>
  </div>

  <div class="edit-container sdt">
    <nts-ext-new-autocomplete-text-box #textBox [appendTo]="appendTo" [decodeProperties]="decodeProperties"
      [searchProperties]="searchProperties" [class.onlyRoot]="!isVisibleNumericPropertyViewModel"
      [externalPropertyViewModel]="externalPropertyViewModel" [tabIndex]="tabIndex" [updateOnBlur]="true"
      [isSearchable]="false" [showCodeInDescription]="showCodeInDescription">
    </nts-ext-new-autocomplete-text-box>
    <nts-numeric-text-box *ngIf="isVisibleNumericPropertyViewModel" [isDisabled]="!numericPropertyViewModel.isEnabled"
      [propertyViewModel]="numericPropertyViewModel" [tabIndex]="tabIndex+1"
      [updateOnBlur]="!numericPropertyViewModel.instantModelChange"></nts-numeric-text-box>

  </div>
</div>
